import {
  DashboardQueryResponseComponent
} from '@shared/modals/dashboard/query/dashboard-query-response/dashboard-query-response.component';
import {
  DashboardQueryCompleteComponent
} from '@shared/modals/dashboard/query/dashboard-query-complete/dashboard-query-complete.component';
import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import {
  DashboardQueryListComponent
} from '@shared/modals/dashboard/query/dashboard-query-list/dashboard-query-list.component';
import {
  ServiceRequestRemoveModalComponent
} from '@shared/modals/dashboard/query/service-request-remove-modal/service-request-remove-modal.component';

export const dashboardReplyModal: ModalConfig = {
  component: DashboardQueryResponseComponent,
  title: 'dashboard.servicerequest.reply.title',
  actions: [
    { type: 'primary', label: 'system.button.reply', method: 'submit' },
    { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
  ]
}

export const dashboardCompleteModal: ModalConfig = {
  component: DashboardQueryCompleteComponent,
  title: 'dashboard.complete.title',
  actions: [
    { type: 'primary', label: 'system.button.send', method: 'submit' },
    { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
  ],
}

export const dashboardListModal: ModalConfig = {
  component: DashboardQueryListComponent,
  title: 'dashboard.list.title',
  actions: [
    { type: 'secondary', label: 'system.button.close', closeOnClick: true },
  ]
}

export const serviceRequestRemoveModal: ModalConfig = {
  component: ServiceRequestRemoveModalComponent,
  title: 'dashboard.servicerequest.remove.title',
  type: 'center',
  actions: [
    { type: 'primary', label: 'system.button.confirm', method: 'submit' },
    { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
  ]
}
